import { render, staticRenderFns } from "./DDDInformationApplication.vue?vue&type=template&id=98403be4&"
import script from "./DDDInformationApplication.vue?vue&type=script&lang=js&"
export * from "./DDDInformationApplication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports